import { useState, useRef, useEffect } from 'react';

interface Props {
    googleLink?: string;
    outlookLink?: string;
    icalendarLink?: string;
    addToCalendarLabel?: string;
}

const AddToCalendarButton = ({ googleLink, outlookLink, icalendarLink, addToCalendarLabel }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const links = [
        { label: 'Google Calendar', href: googleLink, iconClass: 'google' },
        { label: 'Outlook', href: outlookLink, iconClass: 'outlook' },
        { label: 'iCalendar', href: icalendarLink, iconClass: 'ical' }
    ].filter(link => !!link.href);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);


    if (links.length === 1) {
        return (
            <a
                href={links[0].href}
                target="_blank"
                rel="noopener noreferrer"
                className="calendar-add__button single-link-button"
            >
                {addToCalendarLabel || 'Add To Calendar'}
            </a>
        );
    }

    if (links.length > 1) {
        return (
            <div className="calendar-add" ref={dropdownRef}>
                <button
                    className="calendar-add__button dropdown-button"
                    aria-haspopup="true"
                    aria-expanded={isOpen}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {addToCalendarLabel || 'Add To Calendar'}
                </button>
                <div className={`calendar-add__dropdown ${isOpen ? '' : 'hidden'}`} role="menu">
                    {links.map((link, index) => (
                        <a
                            key={index}
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`calendar-add__link link-${link.iconClass}`}
                            role="menuitem"
                        >
                            {link.label}
                        </a>
                    ))}
                </div>
            </div>
        );
    }

    return null;
};

export default AddToCalendarButton;